import { Link } from 'gatsby';
import React from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Layout from '../components/Layout';
import { formatPublishedAt } from '../utils/blog';

const BlogPostTemplate = ({ pageContext }) => {
  const { post } = pageContext;

  const meta = [
    { property: 'og:title', content: post.title },
    { property: 'og:description', content: post.excerpt || '' },
  ];
  if (post.imageUrl) {
    meta.push({ property: 'og:image', content: post.imageUrl });
  }

  return (
    <Layout titlePrefixes={[post.title, 'Blog']} meta={meta}>
      <Header solid />
      <style>{`
        .blog-post-page {
          background: #e8eded;
          padding: 110px 40px 120px;
          min-height: 100vh;
        }
        .blog-post-wrap {
          max-width: 1040px;
          margin: 0 auto;
        }
        .blog-post-back {
          margin: 0 0 1rem;
        }
        .blog-post-back a {
          color: #009e9a;
          font-weight: 600;
        }
        .blog-post-article {
          background: #fff;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 10px 40px rgba(26, 26, 26, 0.08);
          border: 1px solid #dce3e3;
        }
        .blog-post-hero {
          margin: 0;
          background: #dfe6e6;
        }
        .blog-post-hero img {
          display: block;
          width: 100%;
          height: auto;
          aspect-ratio: 16 / 9;
          object-fit: cover;
        }
        .blog-post-header {
          padding: 2rem 2.75rem 0;
        }
        .blog-post-header h1 {
          font-size: 2.15rem;
          line-height: 1.25;
          font-weight: 700;
          color: #1a1a1a;
          margin: 0 0 0.5rem;
        }
        .blog-post-date {
          margin: 0;
          color: #6c757d;
        }
        .blog-post-body {
          padding: 1.5rem 2.75rem 3rem;
        }
        .blog-post-page .blogContent h1,
        .blog-post-page .blogContent h2,
        .blog-post-page .blogContent h3 {
          font-size: 1.35rem;
        }
        .blog-post-page .blogContent h1 {
          font-size: 1.6rem;
        }
        @media (max-width: 767px) {
          .blog-post-page {
            padding: 96px 12px 48px;
          }
          .blog-post-header,
          .blog-post-body {
            padding-left: 1.25rem;
            padding-right: 1.25rem;
          }
          .blog-post-header h1 {
            font-size: 1.7rem;
          }
        }
      `}</style>

      <section className="blog-post-page">
        <div className="blog-post-wrap">
          <p className="blog-post-back">
            <Link to="/blog">← Blog</Link>
          </p>

          <article className="blog-post-article">
            {post.imageUrl && (
              <div className="blog-post-hero">
                <img src={post.imageUrl} alt="" />
              </div>
            )}

            <header className="blog-post-header">
              <h1>{post.title}</h1>
              {post.publishedAt && (
                <p className="blog-post-date">
                  {formatPublishedAt(post.publishedAt)}
                </p>
              )}
            </header>

            <div
              className="blog-post-body blogContent markdownContainer"
              dangerouslySetInnerHTML={{ __html: post.contentHtml }}
            />
          </article>
        </div>
      </section>

      <Footer />
    </Layout>
  );
};

export default BlogPostTemplate;
